import FundingProgramDetail from 'components/global/FundingProgramDetail';

const BusinessFundingProgramDetail = () => <FundingProgramDetail />;

export default BusinessFundingProgramDetail;
